import { useState, useEffect } from 'react'

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<string[]>([])

  useEffect(() => {
    const storedFavorites = localStorage.getItem('favorite_tools')
    if (storedFavorites) {
      setFavorites(JSON.parse(storedFavorites))
    }
  }, [])

  const toggleFavorite = (itemIdentifier: string) => {
    const newFavorites = favorites.includes(itemIdentifier)
      ? favorites.filter(fav => fav !== itemIdentifier)
      : [...favorites, itemIdentifier]
    setFavorites(newFavorites)
    localStorage.setItem('favorite_tools', JSON.stringify(newFavorites))
  }

  return { favorites, toggleFavorite }
}
